import React from "react"
import catData from "./catData.js"
import MajorCatCard from "./catCard"

function createCard(data) {
  return (
    <MajorCatCard
      catName={data.catName}
      catIcon={data.catIcon}
      catLink={data.catLink}
    />
  )
}

export default function ProductCategory() {
  return (
    <div className="product-cat-div">
      <h3>Shop by category</h3>
      <div className="p-c-flex">{catData.map(createCard)}</div>
    </div>
  )
}
